export const mapionSdkOrigin = process.env.NODE_ENV === 'production' ? 'https://bizapis.mapion.co.jp' : 'https://bizapis-stg.mapion.co.jp'